import { makeStyles } from "@material-ui/core";
import { Chart, Area, Tooltip, Axis, Legend } from "bizcharts";
import { useSelector } from "react-redux";
import UtilService from "../../../../../../../helper/service";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    overflow: 'hidden',
    zIndex: 3,
  },
  graph: {
    position: 'absolute',
    opacity: 0.8
  },
  square: {
    background: '#d6d8dB',
    borderRight: '1px solid #fff',
    borderTop: '4px solid #1DB859',
    fontSize: 33,
    fontFamily: 'Spartan-bold',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingBottom: 5,
    zIndex: -1,
    width: 15,
    borderTopWidth: 2,
  },
  chart: {
    '& canvas': {
      height: '200px!important',
    }
  }
}));

function CoreAnalysisLineBarGraph(props: any) {

  const classes = useStyles();
  const { module4Settings, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { module4Data } = userPreferences;
  const { session, analyze } = module4Data.value;
  const { session_type } = session;
  const stimulus = analyze.stimulus;
  const { graphZoom, analyseStart, analyseEnd } = module4Settings;
  const { graphData, width, playPosition, marginTop, marginBottom, popOut } = props;
  const { data } = graphData;

  const filterData = (data ? data : [])
    .map((item: any) => {
      return {
        value: item.immersion_index,
        timestamp: (session_type === 'ASYNC')
          ? (UtilService.getLocalEpoch2(item.time_stamp) - UtilService.getLocalEpoch2("1970-01-01 00:00:00"))
          : UtilService.getLocalEpoch2(item.time_stamp)
      }
    })

  const myData = filterData
    .reduce((prev: any[], c: any, index: number) => {
      if (index < data.length && index > 0) {
        const timeDiff = Math.abs(c.timestamp - filterData[index - 1].timestamp)
        if (timeDiff > 1) {
          for (let i = 1; i < timeDiff; i++) {
            prev.push({
              value: 0,
              timestamp: filterData[index - 1].timestamp + i
            })
          }
        }
      }
      prev.push(c)
      return prev
    }, [])
    .sort(function (a: any, b: any) {
      return a.timestamp - b.timestamp
    })

  const scale = {
    value: {
      min: 0,
      max: 105,
      nice: true,
    },
    timestamp: {
      min: session_type === 'ASYNC' ? 0 : analyseStart,
      max: session_type === 'ASYNC' ? stimulus?.stimulus_video_length : analyseEnd,
    },
  };

  return (
    <div
      className={classes.root}
      style={{
        height: 192,
        width: width,
        marginTop: marginTop ? marginTop : 60,
        marginBottom: marginBottom ? marginBottom : 70,
      }}
    >

      <div style={{ width: '100%', height: '100%' }}>

        <div style={{ position: 'absolute', width: playPosition, height: 190, background: '#00000040', transition: '1.5s linear', }} />

        <Chart
          className={classes.chart}
          scale={scale}
          data={myData}
          animate={false}
          autoFit
          onClick={(ev: any) => {
            const xPos = ev.gEvent.x;
            const time = xPos * Math.pow(graphZoom, 2) / 15;
            if (popOut) {
              if(stimulus?.stimulus_video_length && time > stimulus?.stimulus_video_length && session_type === 'ASYNC') return false
              popOut(time);
            }
          }}
        >
          <Axis name="value" visible={false} />
          <Axis name="timestamp" visible={false} />
          <Legend visible={false} />
          <Tooltip visible={false} />
          <Area position="timestamp*value" color={'grey'} animate={{
            enter: {
              duration: 1000,
            },
            leave: false,
          }} />
        </Chart>
      </div>
    </div>
  );
}

export default CoreAnalysisLineBarGraph;